import React from "react";
import { ValidatorInterface } from "module/validation/types";
import FormHelperText from "@mui/material/FormHelperText";
import ValidationMessage from "module/validation/ValidationMessage";

interface Props {
  errors: ValidatorInterface[];
}
// TODO: remove
const ValidationErrorMessage: React.FC<Props> = ({ errors }) => {
  const hasError = Boolean(errors.length);

  if (hasError) {
    return (
      <FormHelperText error>
        <ValidationMessage validators={errors} />
      </FormHelperText>
    );
  }
  return null;
};

export default React.memo(ValidationErrorMessage);
